module.exports = __webpack_public_path__ + "static/media/reg5.fe030095.jpg";